import { UserRequester } from '@cobliteam/api-lib';

import type { AccessibleFleet, User } from '@cobliteam/common-types';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import { Environment } from '@cobliteam/react-environments';
import {
  deleteUserRequestFailed,
  deleteUserRequestSucceeded,
  loadAccessibleFleetsSucceeded,
  loadUsersRequestFailed,
  loadUsersRequestSucceeded,
} from '@cobliteam/store/src/Users/actionCreators';
import type { DeleteUserRequest } from '@cobliteam/store/src/Users/actions';
import { UsersActionTypes } from '@cobliteam/store/src/Users/actionTypes';
import Alert from '@cobliteam/ui/components/Alert';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const env = Environment.getInstance().getEnvironment();

export class UsersSagas {
  private userRequester: UserRequester;

  constructor(userRequester: UserRequester) {
    this.userRequester = userRequester;
    this.requestLoadFleetUsersSaga = this.requestLoadFleetUsersSaga.bind(this);
    this.requestDeleteUserSaga = this.requestDeleteUserSaga.bind(this);
    this.requestLoadAcessibleFleets = this.requestLoadAcessibleFleets.bind(this);
  }

  public *requestLoadFleetUsersSaga() {
    try {
      const session = useSessionStore.getState().session;

      if (session) {
        const fleetId = session.fleet.id;
        const fleetUsers: User[] = yield call(this.userRequester.getFleetUsers, fleetId);
        yield put(loadUsersRequestSucceeded(fleetUsers));
      }
    } catch (err) {
      yield put(loadUsersRequestFailed());
      Alert.error('Houve um erro, tente novamente mais tarde.');
    }
  }

  public *requestDeleteUserSaga(action: DeleteUserRequest) {
    try {
      const session = useSessionStore.getState().session;

      if (session) {
        yield call(this.userRequester.deleteFleetUser, action.payload.id);
        yield put(deleteUserRequestSucceeded());
        Alert.success('Usuário excluído com sucesso!');
      }
    } catch (err) {
      yield put(deleteUserRequestFailed());
      Alert.error('Houve um erro, tente novamente mais tarde.');
    }
  }

  public *requestLoadAcessibleFleets() {
    try {
      const accessibleFleets: AccessibleFleet[] = yield call(this.userRequester.getUserAcessibleFleets);
      yield put(loadAccessibleFleetsSucceeded(accessibleFleets));
    } catch (err) {
      Alert.error('Houve um erro, tente novamente mais tarde.');
    }
  }
}

export function* UserSagasListener() {
  const usersSagas = new UsersSagas(new UserRequester({ host: env.herbieApiHost }));
  yield all([
    takeLatest(UsersActionTypes.LOAD_USERS_REQUEST, usersSagas.requestLoadFleetUsersSaga),
    takeLatest(UsersActionTypes.DELETE_USER_REQUEST, usersSagas.requestDeleteUserSaga),
    takeLatest(UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_REQUEST, usersSagas.requestLoadAcessibleFleets),
  ]);
}
